module.exports = __webpack_public_path__ + "img/logo.dbe300df.svg";